import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CommonModule } from '@angular/common';
import {
  PoButtonModule,
  PoComboFilterMode,
  PoFieldModule,
  PoInfoModule,
  PoLoadingModule,
  PoPageModule
} from '@po-ui/ng-components';
import { FormsModule } from '@angular/forms';
import { ProductionService } from '../../../shared/service/production.service';
import { CountService } from '../../../shared/service/count.service';
import { MovementService } from '../../../shared/service/movement.service';
import { ToasterService } from '../../../shared/service/toaster.service';
import { ToasterComponent } from '../../../shared/components/toaster/toaster.component';
import { ProductionOrderService } from '../../../shared/service/production-order.service';

@Component({
  standalone: true,
  selector: 'app-count-details',
  templateUrl: './count-details.component.html',
  styleUrls: ['./count-details.component.css'],
  imports: [
    CommonModule,
    FormsModule,
    PoPageModule,
    PoButtonModule,
    PoInfoModule,
    PoFieldModule,
    PoLoadingModule,
    ToasterComponent
  ]
})
export class CountDetailsComponent implements OnInit {

  isLoading: boolean = true;
  isOPFinished: boolean = false;
  size = 'sm';
  text = 'Carregando';

  allLocations: any[] = [];

  countDetails = {
    code: '0',
    quantity: 0,
    pack: 0,
    items: [],
    originLocation: 0,
    destinationLocation: 0
  };

  filterMode = PoComboFilterMode.contains;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private productionService: ProductionService,
    private countService: CountService,
    private movementService: MovementService,
    private toasterService: ToasterService,
    private productionOrderService: ProductionOrderService,
  ) {


    this.isOPFinished = false;
  }

  ngOnInit(): void {
    const branchCode = Number(this.route.snapshot.paramMap.get('branchCode'));
    const countCode = Number(this.route.snapshot.paramMap.get('countCode'));

    this.loadLocations().then(() => {
      this.loadCount(branchCode, countCode);
      this.loadOutputCountAdditionals(branchCode, countCode);
    });
  }

  loadLocations(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.productionService.searchPlaces('').subscribe({
        next: (res: any) => {
          this.allLocations = res.items.map((item: any) => ({
            placeCode: Number(item.code),
            placeDescription: item.description,
            displayLabel: `${item.code} - ${item.description}`
          }));
          this.isLoading = false;
          resolve();
        },
        error: (err: any) => {
          console.error('Failed to load locations', err);
          this.isLoading = false;
          reject(err);
        }
      });
    });
  }

  loadCount(branchCode: number, countCode: number): void {
    this.countService.getCountByCode(branchCode, countCode).subscribe({
      next: (res: any) => {
        this.countDetails.code = res.code;
        this.countDetails.items = res.items.sort((a: any, b: any) => b.sequence - a.sequence);

        const quantities = res.items?.map((item: any) => item.quantity) || [];
        this.countDetails.quantity = quantities.reduce((sum: number, val: number) => sum + val, 0);

        const uniquePacks = new Set(
          res.items?.map((item: any) => item.pack).filter((p: any) => p !== undefined && p !== null)
        );

        this.countDetails.pack = uniquePacks.size;
      },
      error: (err: any) => {
        console.error('Erro ao buscar contagem:', err);
      }
    });
  }
  loadOutputCountAdditionals(branchCode: number, countCode: number): void {
    this.countService.getOutputCountAdditionals(branchCode, countCode).subscribe({
      next: (res: any) => {
        console.log('Dados adicionais de contagem:', res);


        if (res && res.additional) {
          this.countDetails.originLocation = res.additional.placeOrigin || 0;
          this.countDetails.destinationLocation = res.additional.placeDestination || 0;
        }
      },
      error: (err) => {
        this.toasterService.triggerAlert('Falha ao carregar informações adicionais.', 'error');
      }
    });
  }

  goBack(): void {
    this.router.navigate(['/production-order-movement']);
  }

  clearFields(): void {
    this.countDetails.originLocation = 0;
    this.countDetails.destinationLocation = 0;
    console.log('Fields cleared');
  }

  showItems(): void {
    const origin = this.allLocations.find(
      l => l.placeCode === Number(this.countDetails.originLocation)
    );
    const destination = this.allLocations.find(
      l => l.placeCode === Number(this.countDetails.destinationLocation)
    );

    this.router.navigate(['/count-items'], {
      state: {
        countDetails: {
          ...this.countDetails,
          originLocation: origin,
          destinationLocation: destination
        }
      }
    });
  }

  showItemsPerPack(): void {
    console.log('Showing items per pack');
  }

  get isLocationSelectionValid(): boolean {
    return !!this.countDetails.originLocation && !!this.countDetails.destinationLocation;
  }

  async moveOp(componentName: string): Promise<void> {
    this.isLoading = true;
    this.text = 'Movimentando OP';

    const branchCode = Number(this.route.snapshot.paramMap.get('branchCode'));
    const countCode = Number(this.route.snapshot.paramMap.get('countCode'));
    const contentToTomas = this.movementService.generateMessageContentToTomas(this.countDetails, componentName);

    const payload = this.movementService.generateContentMovementTomas(
      branchCode,
      JSON.stringify(contentToTomas)
    );

    try {

      const result = this.movementService.sendApiMovementTomas(payload).subscribe({
        next: (data) => {
          if (data && data.status == 200 && data.tomasResponse) {
            this.toasterService.triggerAlert(data.tomasResponse.message, data.tomasResponse.status.toLocaleLowerCase());
          }



          if (data.tomasResponse.status.toLocaleLowerCase() === 'success') {
            this.countService.postUpdateCountStatus(branchCode, countCode, 5).subscribe({
              next: (data) => {
                this.toasterService.triggerAlert("Contagem Finalizada", 'success');
                this.isOPFinished = true;
                this.router.navigate(['/production-order-movement']);
              },
              error: (error: any) => {
                this.toasterService.triggerAlert('Falha ao atualizar o status da contagem.', 'error');
                this.isLoading = false;
              }
            })
          }
          this.isLoading = false;
        },
        error: (error: any) => {
          this.toasterService.triggerAlert('Falha ao executar a movimentação.', 'error');
          this.isLoading = false;
        }
      });

    } catch (error) {
      console.error('Erro ao movimentar OP:', error);
      alert('Erro inesperado na movimentação.');
    } finally {

    }
  }


  onOriginLocationChange(value: number): void {
    this.countDetails.originLocation = value;
    this.triggerCountAdditional();
  }

  onDestinationLocationChange(value: number): void {
    this.countDetails.destinationLocation = value;
    this.triggerCountAdditional();
  }

  triggerCountAdditional(): void {
    const branchCode = Number(this.route.snapshot.paramMap.get('branchCode'));
    const countCode = Number(this.route.snapshot.paramMap.get('countCode'));

    if (!this.countDetails.originLocation || !this.countDetails.destinationLocation) {
      return;
    }

    const payload = {
      branchCode: branchCode,
      code: countCode,
      additional: {
        placeOrigin: this.countDetails.originLocation,
        placeDestination: this.countDetails.destinationLocation
      }
    };

    this.countService.postCountAdditional(
      payload.branchCode,
      payload.code,
      payload.additional,
    ).subscribe({
      next: () => {
        this.toasterService.triggerAlert('Informações atualizadas com sucesso', 'success');
      },
      error: (err) => {
        this.toasterService.triggerAlert('Falha ao atualizar informações adicionais.', 'error');
      }
    });
  }


}
